/*
 * @@Description: 自定义层
 * @@Author: MuYang
 * @Date: 2021-08-24 15:48:26
 */

import STable from './warp/table'
import {
  cellForced,
  paginationDefaultConfig,
  INDEX_CONFIG,
  PREFIX
} from '../util/config'
import { TableProps } from '../util/default-props'
import createdSelected from '../extend/select-store'
import FilterDropdown from '../extend/filter-dropdown'
import { processClass, processStyle } from '../util/column-manager'

export default {
  name: 'SyVcTable',
  components: {
    STable,
    FilterDropdown
  },
  props: {
    ...TableProps
  },

  computed: {
    // 支持两种方式 1.table上直接设置配置 2.sy-column组件
    realSelect () {
      return this.rowSelection || this.defaultSelection
    }
  },

  data () {
    return {
      defaultSelection: { selectedRows: [] },
      expandRows: []
    }
  },

  watch: {
    realSelect: {
      handler (val) {
        this.selectStore && this.selectStore.update(val)
      },
      immediate: true,
      deep: true
    },
    dataSource (val) {
      console.log('================11====2=====================')
      this.selectStore && this.selectStore.updateData(val)
      this.initRowExpansion(val)
    },
    columns: {
      handler (val) {
        this.renderFiltrate(val)
      },
      immediate: true
    }
  },

  methods: {
    // 切换选中状态 对外
    toggleRowSelection ({ rows, state: selectState }) {
      if (!this.selectStore) return
      if (Array.isArray(rows)) {
        rows.forEach((row, index) => {
          this.selectStore.toggleRowSelection(row, index, selectState)
        })
      } else {
        this.selectStore.toggleRowSelection(rows, null, selectState)
      }
    },
    initRowExpansion (val) {
      if (this.defaultExpandAll) {
        this.expandRows = val.slice()
      }
    },
    // 拓展区
    toggleRowExpansion ({rows, expanded}) {
      if (Array.isArray(rows)) {
        rows.forEach((row) => {
          this.updateExpandRows(row, expanded)
        })
      } else {
        this.updateExpandRows(rows, expanded)
      }
    },
    updateExpandRows (row, expanded) {
      const index = this.expandRows.indexOf(row)
      if (typeof expanded === 'boolean') {
        if (expanded && index === -1) {
          this.expandRows.push(row)
          console.log(this.expandRows, row)
          return
        }
        if (!expanded && index !== -1) {
          this.expandRows.splice(index, 1)
          return
        }
      }
      if (index === -1) {
        this.expandRows.push(row)
      } else {
        this.expandRows.splice(index, 1)
      }
    },
    // 对外 重置选中
    resetSelection () {
      if (!this.selectStore) return
      this.selectStore.resetSelection()
    },
    // 分页
    renderPagination () {
      let { pagination, dataSource = [] } = this

      if (!pagination || dataSource.length === 0) {
        return null
      }

      Object.keys(paginationDefaultConfig).forEach(key => {
        if (!pagination[key]) {
          pagination[key] = paginationDefaultConfig[key]
        }
      })

      let { currentPage, change, pageSize } = pagination

      const paginationProps = {
        key: 'pagination-bottom',
        class: `${PREFIX}-pagination`,
        props: { ...pagination },
        on: {
          'size-change': val => {
            pageSize = val
            change(currentPage, val)
          },
          'current-change': val => {
            currentPage = val
            change(val, pageSize)
          }
        }
      }
      return <el-pagination {...paginationProps}></el-pagination>
    },

    // index
    renderRowIndex (cols) {
      const columns = [...cols]
      const indexColumn = this.findAssignColumn(columns, 'index')
      if (this.rowIndex || indexColumn) {
        let column = Object.assign({}, INDEX_CONFIG, this.rowIndex, indexColumn)
        column.customRender = ({ $index: index }) => {
          return cellForced.index.renderCell.call(this, this.$createElement, {
            index: column.render(index) || index + 1
          })
        }

        if (columns.some(column => column.fixed && column.fixed !== 'right')) {
          column.fixed = 'left'
        }
        columns.unshift(column)
      }
      return columns
    },

    // 判断有没有sy-columns
    findAssignColumn (columns, type = 'selection') {
      const selectIndex = columns.findIndex(column => column.type === type)
      const selectColumn = columns[selectIndex]
      selectColumn && columns.splice(selectIndex, 1)
      return selectColumn
    },

    // 渲染selection
    renderSelection (cols) {
      // 先判断 需不需要selection
      const columns = [...cols]
      const selectColumn = this.findAssignColumn(columns)
      if (this.rowSelection || selectColumn) {
        // 已经生成直接走缓存
        if (this.selectStore) {
          return this.selectStore.renderRowSelection(columns, selectColumn)
        }
        this.selectStore = createdSelected({
          dataSource: this.dataSource,
          rowSelection: this.realSelect,
          createElement: this.$createElement,
          rowKey: this.rowKey,
          columns
        })
        return this.selectStore.renderRowSelection(columns, selectColumn)
      }
      this.selectStore = null
      return columns
    },

    // 筛选
    renderFiltrate (cols) {
      const columns = [...cols]
      let column
      for (let i = 0; i < columns.length; i++) {
        column = columns[i]
        if (column.type === 'filtrate') {
          column.title = <FilterDropdown column={column} title={column.title} colIndex={i}/>
          // 渲染默认
        }
      }
      return columns
    },
    // 展开更多
    renderExpand (cols) {
      const columns = [...cols]
      let expandColumn = this.findAssignColumn(columns, 'expand')
      return { expandColumn, columns }
    },
    
    // 渲染主题table
    renderTable () {
      const indexColumns = this.renderRowIndex(this.columns)
      const columnsWithRowSelection = this.renderSelection(indexColumns)
      const { expandColumn, columns } = this.renderExpand(
        columnsWithRowSelection
      )
      let leftPos = 0
      columns.forEach((column, index) => {
        processClass(column, columns, index)
        leftPos = processStyle(column, columns, leftPos)
      })
      const tProps = {
        props: {
          ...this.$props,
          expandRows: this.expandRows,
          columns,
          expandColumn
        }
      }
      return <STable {...tProps} />
    },

    // 分页
    handleSizeChange (val) {
      console.log(val)
    }
  },

  render (h) {
    // console.log('==================vc===============')
    return (
      <div class={`${PREFIX}-outer`}>
        {this.renderTable()}
        {/* {this.renderPagination()} */}
      </div>
    )
  },
  mounted () {
    this.initRowExpansion(this.dataSource)
  },
  // 销毁
  destroy () {
    this.selectStore = null
  }
}
